import { useState, useEffect } from 'react';
import { navLinks } from '@/mocks/homeContent';
import LineIcon from '@/components/base/LineIcon';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
          scrolled
            ? 'bg-background-50 border-b border-background-200'
            : 'bg-transparent'
        }`}
      >
        <div className="w-full px-4 md:px-6 lg:px-10 flex items-center justify-between h-16 md:h-[68px]">
          <a
            href="#top"
            onClick={(e) => {
              e.preventDefault();
              scrollTo('#top');
            }}
            className="flex items-center shrink-0 cursor-pointer mr-4"
          >
            <span className="font-heading font-bold text-lg md:text-xl text-foreground-950 tracking-wide whitespace-nowrap">
              吉川産業
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-1 xl:gap-5">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => {
                  e.preventDefault();
                  scrollTo(link.href);
                }}
                className="text-[13px] xl:text-sm font-medium text-foreground-600 hover:text-primary-600 whitespace-nowrap cursor-pointer px-2 py-1.5 transition-colors"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2 md:gap-3">
            <a
              href="tel:+81120219620"
              className="hidden md:inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 font-bold text-xs md:text-sm whitespace-nowrap cursor-pointer transition-colors"
            >
              <span className="w-4 h-4 flex items-center justify-center text-sm">
                <i className="ri-phone-fill" />
              </span>
              <span className="hidden lg:inline">0120-219-620</span>
              <span className="lg:hidden">電話</span>
            </a>

            <a
              href="https://lin.ee/yKaHc4I"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-md bg-accent-700 hover:bg-accent-800 text-background-50 font-bold text-xs md:text-sm whitespace-nowrap cursor-pointer transition-colors"
            >
              <LineIcon className="w-[18px] h-[18px] shrink-0" />
              <span className="hidden sm:inline">LINEで無料相談</span>
              <span className="sm:hidden">LINE</span>
            </a>

            <a
              href="tel:+81120219620"
              className="md:hidden w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50 cursor-pointer"
              aria-label="電話"
            >
              <span className="w-5 h-5 flex items-center justify-center text-lg">
                <i className="ri-phone-fill" />
              </span>
            </a>

            <button
              aria-label="メニュー"
              onClick={() => setMobileOpen(!mobileOpen)}
              className="lg:hidden w-9 h-9 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 cursor-pointer transition-colors"
            >
              <span className="w-5 h-5 flex items-center justify-center text-xl">
                <i className={mobileOpen ? 'ri-close-line' : 'ri-menu-line'} />
              </span>
            </button>
          </div>
        </div>
      </header>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="lg:hidden fixed inset-0 z-40 bg-background-50 pt-16">
          <nav className="flex flex-col p-6 gap-2">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => {
                  e.preventDefault();
                  scrollTo(link.href);
                }}
                className="text-base font-medium text-foreground-700 hover:text-primary-600 py-3 border-b border-background-200 cursor-pointer transition-colors"
              >
                {link.label}
              </a>
            ))}
            <div className="mt-4 flex flex-col gap-3">
              <a
                href="tel:+81120219620"
                className="flex items-center justify-center gap-2 px-4 py-3 rounded-md bg-primary-500 text-background-50 font-bold text-sm whitespace-nowrap cursor-pointer"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-fill" />
                </span>
                電話で今すぐ相談
              </a>
              <a
                href="https://lin.ee/yKaHc4I"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 px-4 py-3 rounded-md bg-accent-700 text-background-50 font-bold text-sm whitespace-nowrap cursor-pointer"
              >
                <LineIcon className="w-[18px] h-[18px] shrink-0" />
                LINEで無料見積り
              </a>
            </div>
          </nav>
        </div>
      )}
    </>
  );
}